module.exports = __webpack_public_path__ + "img/all-sports.53f2d487.svg";